import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaLib from '@abcya/abcya_lib';
import PlayScene from '../scenes/PlayScene';

export default class PlayerInput {
  /**
   * 
   * @param {PlayScene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    this.acceptInput = true;
    this.motionControls = false;
    this.motionAcceleration = null;

    this.init();
  }

  init () {
    if (gameData.config.hasMotionControls) {
      this.motionControls = true;
      this.motionAcceleration = 0;

      this.implementationFix = 1;
      if (ABCyaLib.DEVICE_INFO.iOS) {
        this.implementationFix = -1;
      }

      this.handleMotionInputBind = this.handleMotionInput.bind(this);

      // TODO use this instead once the package works with accelerationWithGravity
      // ABCyaLib.Sensors.instance.events.on(ABCyaLib.Sensors.SENSOR_EVENTS.ON_MOTION, this.handleMotionInputBind);
      // ABCyaLib.Sensors.instance.startMotionSensor();

      window.addEventListener('devicemotion', this.handleMotionInputBind);

    }
    if (ABCyaLib.DEVICE_INFO.desktop) {
      this.leftArrowKey = this.scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT);
      this.rightArrowKey = this.scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT);
    }
  }

  checkInput () {
    if (!this.acceptInput) return false;
    if (this.motionControls) {
      this.scene.inputAxisX(this.motionAcceleration, true);
    }
    else {
      this.checkPhysicalInput();
    }
    return true;
  }

  checkPhysicalInput () {
    if ((this.leftArrowKey !== undefined && this.leftArrowKey.isDown) || this.clickInputValue === 'LEFT') {
      this.scene.inputAxisX(-1, false);
    }
    else if ((this.rightArrowKey !== undefined && this.rightArrowKey.isDown) || this.clickInputValue === 'RIGHT') {
      this.scene.inputAxisX(1, false);
    }
    else {
      if (!this.motionControls) this.scene.inputAxisX(0, false);
    }
  }

  handleMotionInput (event) {
    const x = -event.accelerationIncludingGravity.x * this.implementationFix;
    this.motionAcceleration = x * 100;
  }

  clickInput (dir) {
    if (dir === -1) {
      this.clickInputValue = 'LEFT';
    }
    else if (dir === 1) {
      this.clickInputValue = 'RIGHT';
    }
    else {
      this.clickInputValue = 'NONE';
    }
  }

  cleanup() {
    // ABCyaLib.Sensors.instance.events.off(ABCyaLib.Sensors.SENSOR_EVENTS.ON_MOTION, this.handleMotionInputBind);
    // ABCyaLib.Sensors.instance.stopMotionSensor();

    window.removeEventListener('devicemotion', this.handleMotionInputBind);
  }
}